import styled, { css } from 'styled-components'

export const Toolbar = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['12']};
  `,
)

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['12']};
    flex-shrink: 0;
  `,
)

export const EssentialsList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.space['8']};
    width: 100%;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  `,
)

export const LoaderWrapper = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  `,
)
